/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonFoodData,
    JsonFoodDataFromJSON,
    JsonFoodDataFromJSONTyped,
    JsonFoodDataToJSON,
} from './JsonFoodData';

/**
 * 
 * @export
 * @interface JsonEventPartyDayInfo
 */
export interface JsonEventPartyDayInfo {
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    acmCnt?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    acmId?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonEventPartyDayInfo
     */
    allowedActions?: Array<JsonEventPartyDayInfoAllowedActionsEnum>;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyDayInfo
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    createdBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    eventDayId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    eventPartyDayId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    eventPartyId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    foodBrId?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof JsonEventPartyDayInfo
     */
    foodCnt?: { [key: string]: number; };
    /**
     * 
     * @type {JsonFoodData}
     * @memberof JsonEventPartyDayInfo
     */
    foodData?: JsonFoodData;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    foodDiId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    foodLuId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    foodSnId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    parkCnt?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    parkFlag?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    parkId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyDayInfo
     */
    parkPlates?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    parkRec?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyDayInfo
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyDayInfo
     */
    updatedBy?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonEventPartyDayInfoAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}

export function JsonEventPartyDayInfoFromJSON(json: any): JsonEventPartyDayInfo {
    return JsonEventPartyDayInfoFromJSONTyped(json, false);
}

export function JsonEventPartyDayInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonEventPartyDayInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'acmCnt': !exists(json, 'acmCnt') ? undefined : json['acmCnt'],
        'acmId': !exists(json, 'acmId') ? undefined : json['acmId'],
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'eventDayId': !exists(json, 'eventDayId') ? undefined : json['eventDayId'],
        'eventPartyDayId': !exists(json, 'eventPartyDayId') ? undefined : json['eventPartyDayId'],
        'eventPartyId': !exists(json, 'eventPartyId') ? undefined : json['eventPartyId'],
        'foodBrId': !exists(json, 'foodBrId') ? undefined : json['foodBrId'],
        'foodCnt': !exists(json, 'foodCnt') ? undefined : json['foodCnt'],
        'foodData': !exists(json, 'foodData') ? undefined : JsonFoodDataFromJSON(json['foodData']),
        'foodDiId': !exists(json, 'foodDiId') ? undefined : json['foodDiId'],
        'foodLuId': !exists(json, 'foodLuId') ? undefined : json['foodLuId'],
        'foodSnId': !exists(json, 'foodSnId') ? undefined : json['foodSnId'],
        'parkCnt': !exists(json, 'parkCnt') ? undefined : json['parkCnt'],
        'parkFlag': !exists(json, 'parkFlag') ? undefined : json['parkFlag'],
        'parkId': !exists(json, 'parkId') ? undefined : json['parkId'],
        'parkPlates': !exists(json, 'parkPlates') ? undefined : json['parkPlates'],
        'parkRec': !exists(json, 'parkRec') ? undefined : json['parkRec'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function JsonEventPartyDayInfoToJSON(value?: JsonEventPartyDayInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'acmCnt': value.acmCnt,
        'acmId': value.acmId,
        'allowedActions': value.allowedActions,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'eventDayId': value.eventDayId,
        'eventPartyDayId': value.eventPartyDayId,
        'eventPartyId': value.eventPartyId,
        'foodBrId': value.foodBrId,
        'foodCnt': value.foodCnt,
        'foodData': JsonFoodDataToJSON(value.foodData),
        'foodDiId': value.foodDiId,
        'foodLuId': value.foodLuId,
        'foodSnId': value.foodSnId,
        'parkCnt': value.parkCnt,
        'parkFlag': value.parkFlag,
        'parkId': value.parkId,
        'parkPlates': value.parkPlates,
        'parkRec': value.parkRec,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
    };
}

